import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import AuthenticatedRoute from 'app/routes/AuthenticatedRoute';
import AccountRequiredRoute from 'app/routes/AccountRequiredRoute';
import NotFoundPage from 'app/components/NotFoundPage';
import MainLayout from 'app/components/layouts/MainLayout';
import EventsSearchPageRoute from './EventsSearchPageRoute';
import MyEventsPageRoute from './MyEventsPageRoute';

const basePath = '/v2/events';

export default (
  <Route path={basePath}>
    <MainLayout>
      <Switch>
        <Route exact path={basePath}>
          <EventsSearchPageRoute />
        </Route>
        <AuthenticatedRoute>
          <AccountRequiredRoute>
            <Route path={`${basePath}/account/upcoming`}>
              <MyEventsPageRoute />
            </Route>
            <Route exact path={`${basePath}/account/past`}>
              <MyEventsPageRoute past />
            </Route>
            <Route exact path={`${basePath}/account`}>
              <Redirect to={`${basePath}/account/upcoming`} />
            </Route>
          </AccountRequiredRoute>
        </AuthenticatedRoute>
        <Route>
          <NotFoundPage />
        </Route>
      </Switch>
    </MainLayout>
  </Route>
);
